import React from 'react';
import { ALBA_SUB_CATEGORIES } from '../../utils/albaFlowRules';

const ALBA_IMAGES = {
  magic: '/images/macrocagetorie/Alba-Magic.png',
  circle: '/images/macrocagetorie/Alba-Circle.png',
  square: '/images/macrocagetorie/Alba-Square.png',
  mini: '/images/macrocagetorie/Alba-mini.png',
};

const AlbaSubCategorySelector = ({ onSelect }) => {
  const categories = ALBA_SUB_CATEGORIES.filter(c => c.id !== 'accessori');

  return (
    <div className="text-center">
      <h1 className="text-xl font-bold mb-4">SELEZIONA TIPOLOGIA ALBA</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => onSelect(cat.id)}
            className="p-4 border rounded-lg border-gray-300 hover:bg-red-100 hover:border-red-500 transition-colors duration-200"
          >
            <div className="flex flex-col items-center">
              <div className="w-full h-20 mb-2 flex items-center justify-center">
                <img
                  src={ALBA_IMAGES[cat.id]}
                  alt={cat.name}
                  className="h-16 object-contain"
                />
              </div>
              <span className="font-medium">{cat.name}</span>
              {cat.glass && (
                <span className="text-sm text-gray-500 mt-1">Vetro {cat.glass}</span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AlbaSubCategorySelector;
